import ScrollReveal from "../../../components/feature/ScrollReveal";
import { allowedData, prohibitedData } from "../../../mocks/baggageData";

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-24 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12">
              <p className="section-label mb-3">BAGGAGE RULES</p>
              <h2 className="section-title">機内への持ち込みについて</h2>
              <p className="mt-3 text-sm text-airdoa-gray leading-relaxed max-w-2xl mx-auto">
                安全で快適なフライトのため、以下の持ち込みルールをご確認ください。不明な点はお問い合わせください。
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
            {/* OK Column */}
            <ScrollReveal direction="left">
              <div className="bg-airdoa-cream rounded-lg p-6 md:p-8 h-full">
                <div className="flex items-center gap-2.5 mb-6">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-green-600 text-white">
                    <i className="ri-check-line text-lg" />
                  </div>
                  <h3 className="text-lg font-serif font-semibold text-airdoa-navy">
                    持ち込み可能
                  </h3>
                </div>
                <div className="flex flex-col gap-4">
                  {allowedData.items.map((item) => (
                    <div
                      key={item.name}
                      className="flex items-start gap-3 bg-white rounded-md p-4"
                    >
                      <span className="w-5 h-5 flex items-center justify-center text-green-500 shrink-0 mt-0.5">
                        <i className="ri-check-line" />
                      </span>
                      <div>
                        <p className="text-sm font-semibold text-airdoa-navy">
                          {item.name}
                        </p>
                        <p className="mt-0.5 text-xs text-airdoa-gray leading-relaxed">
                          {item.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>

            {/* NG Column */}
            <ScrollReveal direction="right" delay={100}>
              <div className="bg-white border border-red-100 rounded-lg p-6 md:p-8 h-full">
                <div className="flex items-center gap-2.5 mb-6">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-red-500 text-white">
                    <i className="ri-close-line text-lg" />
                  </div>
                  <h3 className="text-lg font-serif font-semibold text-airdoa-navy">
                    持ち込み不可
                  </h3>
                </div>
                <div className="flex flex-col gap-4">
                  {prohibitedData.items.map((item) => (
                    <div
                      key={item.name}
                      className="flex items-start gap-3 bg-red-50/50 rounded-md p-4"
                    >
                      <span className="w-5 h-5 flex items-center justify-center text-red-400 shrink-0 mt-0.5">
                        <i className="ri-close-line" />
                      </span>
                      <div>
                        <p className="text-sm font-semibold text-airdoa-navy">
                          {item.name}
                        </p>
                        <p className="mt-0.5 text-xs text-airdoa-gray leading-relaxed">
                          {item.desc}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}